<!-- HTML -->
<template>
  <div>

    <nav
      class="navbar is-fixed-top is-transparent"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="navbar-brand">
        <transition
          appear
          name="drop-1"
          mode="out-in"
        >
          <router-link to="/">
            <NavMenuLogo />
          </router-link>
        </transition>
        <a
          role="button"
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarBasicExample"
          v-on:click="openCloseMobileMenu"
        >
          <span id="hamburger-bar-1" aria-hidden="true"></span><!-- Hamburger Bar 1 -->
          <span id="hamburger-bar-2" aria-hidden="true"></span><!-- Hamburger Bar 2 -->
          <span id="hamburger-bar-3" aria-hidden="true"></span><!-- Hamburger Bar 3 -->
        </a>
        <!-- Mobile Menu -->
        <div id="mobile-menu" v-on:click="openCloseMobileMenu">
          <router-link to="/" class="navbar-item underline">
            H o m e
          </router-link>
          <router-link to="/music" class="navbar-item underline">
            M u s i c
          </router-link>
          <router-link to="/band" class="navbar-item underline">
            B a n d
          </router-link>
          <a href="https://jugemscloud.bandcamp.com/merch" target="_blank" class="navbar-item underline">
            S t o r e
          </a>
        </div>
        <!-- End Mobile Menu -->
      </div>
      <div id="navbarBasicExample" class="navbar-menu">
        <div class="navbar-start">
        </div>
        <div class="navbar-end">
          <transition
            appear
            name="drop-2"
            mode="out-in"
          >
            <router-link to="/" class="navbar-item underline">
              Home
            </router-link>
          </transition>
          <transition
            appear
            name="drop-3"
            mode="out-in"
          >
            <router-link to="/music" class="navbar-item underline">
              Music
            </router-link>
          </transition>
          <transition
            appear
            name="drop-4"
            mode="out-in"
          >
            <router-link to="/band" class="navbar-item underline">
              Band
            </router-link>
          </transition>
          <transition
            appear
            name="drop-5"
            mode="out-in"
          >
            <a href="https://jugemscloud.bandcamp.com/merch" target="_blank" class="navbar-item underline">
              Store
            </a>
          </transition>
        </div>
      </div>
    </nav>

  </div>
</template>

<!-- JavaScript -->
<script>

import NavMenuLogo from "@/components/navmenu/NavMenuLogo.vue";

export default {

  name: 'NavMenu',

  components: {

    NavMenuLogo

  },

  data() {

    return {

      open: false, // Position of the menu: Open or Close
      transitioning: false // Flag that's set when the mobile menu is transitioning

    }

  },

  methods: {

    openCloseMobileMenu ( ) {

      if ( this.transitioning === false ) {

        // Turn on the transitioning flag to prevent the menu "X" from being clicked mid-transition
        this.transitioning = true;

        if ( this.open === false ) {

          // Display the mobile menu (It's still invisible though)
          document.getElementById('mobile-menu').style.display = 'flex';

          // Slide hamburgers down
          document.getElementById('hamburger-bar-1').classList.add('hamburger-slide');
          document.getElementById('hamburger-bar-2').classList.add('hamburger-slide');
          document.getElementById('hamburger-bar-3').classList.add('hamburger-slide');

          // After 1 second, fade-in the mobile menu
          setTimeout( () => {
            document.getElementById('mobile-menu').classList.add('fade-in');
            this.open = true;
            this.transitioning = false;
          }, 1000);

        } else {

          // Fade-out the mobile menu
          document.getElementById('mobile-menu').classList.remove('fade-in');

          // After .4 seconds, slide the hamburger bars back up
          setTimeout( () => {
            // Slide hamburgers up
            document.getElementById('hamburger-bar-1').classList.remove('hamburger-slide');
            document.getElementById('hamburger-bar-2').classList.remove('hamburger-slide');
            document.getElementById('hamburger-bar-3').classList.remove('hamburger-slide');
          }, 400);

          // After 1.4 seconds, turn off the Transitioning flag
          setTimeout( () => {
            // Undisplay the mobile menu
            document.getElementById('mobile-menu').style.display = 'none';
            this.open = false;
            this.transitioning = false;
          }, 1400);

        }

      }

    }

  }

};

</script>

<!-- CSS -->
<style lang="scss" scoped>

@import "../../assets/scss/variables.scss";
@import "../../assets/scss/transitions.scss";

a:visited {
  color: $gray-tint-2;
}
.navbar {
  margin: 2rem;
}
.navbar-brand img {
  height: 50px;
}
.navbar-burger span {
  color: $gray-tint-2;
}
.navbar-item {
  font-family: astera;
  color: $gray-tint-2;
  padding: 0 3rem;
}
.navbar-item:last-child {
  padding-right: 0;
}
.navbar-item:hover {
  color: $white;
}
.underline {
  display: inline-block;
  margin: 0;
  text-transform: uppercase;
}
.underline:after {
  display: block;
  content: "";
  border-bottom: solid 2px $green-tint-2;
  transform: scaleX(0);
  transition: transform 250ms ease-in-out;
}
.underline:hover:after {
  transform: scaleX(1);
}
.underline.fromRight:after {
  transform-origin: 100% 50%;
}
.underline.fromLeft:after {
  transform-origin: 0% 50%;
}
#hamburger-bar-1 {
  transition: transform .8s ease-in-out;
}
#hamburger-bar-2 {
  transition: transform .8s ease-in-out .2s;
}
#hamburger-bar-3 {
  transition: transform .8s ease-in-out .4s;
}
.hamburger-slide {
  transform: translateY(100vh);
}
#mobile-menu {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  z-index: 10;
  background-color: rgba(10, 10, 10, 0.92);
  display: none;
  opacity: 0;
  transition: opacity .6s;
}
#mobile-menu .navbar-item {
  padding: 2rem;
}
@media all and (min-width: 1024px) {
  #mobile-menu {
    display: none !important;
  }
}
.fade-in {
  opacity: 1 !important;
}

</style>
